<template>
	<div class="hb">
		<div class="hb-cc">
			<div class="hb-h">他们选择了中概</div>
			<div class="hb-b">
				
				<img class="item-h" src="../../assets/hezuo/11@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/12@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/13@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/14@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/15@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/16@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/21@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/22@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/23@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/24@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/25@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/26@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/31@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/32@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/33@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/34@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/35@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/36@2x.png" alt="">
				
				<img class="item-h" src="../../assets/hezuo/41@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/42@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/43@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/44@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/45@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/46@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/51@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/52@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/53@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/54@2x.png" alt="">
				
				<img style="border:1px solid #eee;" class="item-h item-h-ts" src="../../assets/hezuo/76.png" alt="">
				<img style="border:1px solid #eee;" class="item-h item-h-ts" src="../../assets/hezuo/75.png" alt="">
				
				<img class="item-h" src="../../assets/hezuo/61@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/62@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/63@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/64@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/65@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/66@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/71@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/72@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/73@2x.png" alt="">
				<img class="item-h" src="../../assets/hezuo/74@2x.png" alt="">
				 <img class="item-h" src="../../assets/hezuo/55@2x.png" alt="">
				 <img class="item-h" src="../../assets/hezuo/56@2x.png" alt="">
			</div>
			<!-- <div class="hb-more" style="margin-top: 70px;">
				<div>查看更多</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			}
		},
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}
    
	.hb {
		background: #FFFFFF;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
	
		.hb-cc {
			
		}
	
		.hb-h {
			text-align: center;
			color: #333;
		}
	
		.hb-b {
			justify-content: flex-start;
			align-items: center;
			flex-wrap: wrap;
			
		}
	}
	
	@media screen and (min-width: 1200px) {
		.hb {
			width: 100%;
			display: flex;
			padding-bottom: 100px;
			.hb-cc {
				width: 1200px;
				min-width: 1200px;
			}
			.hb-h {
				height: 180px;
				line-height: 180px;
				font-size: 32px;
			}
		
			.hb-b {
				width: 100%;
				display: flex;
				img {
					width: 16.6%;
					height: 8%;
					// border: 2px solid #f1f1f1;					// height: 120px;
					&.item-h-ts{
						width:calc(16.6% - 2px);
					}
				}
			}			
		}
	}
	@media screen and (max-width: 1200px) {
		.hb {
			width: 100%;
			display: flex;
			padding-bottom: 80px;
			.hb-cc {
				width: 100%;
			}
			.hb-h {
				height: 140px;
				line-height: 140px;
				font-size: 26px;
			}
		
			.hb-b {
				width: 100%;
				display: flex;
				img {
					width: 33.33%;
					height: 16%;
					// height: 120px;
				}
			}			
		}
	
	}
	@media screen and (max-width: 880px) {
		.hb {
			width: 100%;
			display: flex;
			padding: 0 12px 30px;
			.hb-cc {
				width: 100%;
			}
			.hb-h {
				height: 80px;
				line-height: 80px;
				font-size: 18px;
			}
		
			.hb-b {
				width: 100%;
				display: flex;
				padding: 0 20px;
			
				img {
					width: 33.33%;
					height: 16%;
				}
			
				.item-h{
					&.item-h-ts{
						width:49.3%;
					}
				}
			}			
		}
	
	}
</style>
